import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {
  BLEND_ATTRIBUTE_GLYPHS,
  BLEND_ATTRIBUTE_ICONS,
} from 'src/components/blend-check/blendCheckIcons';

const BlendAttributeIcon = ({ attributeKey, className }) => {
  const Glyph = BLEND_ATTRIBUTE_GLYPHS[attributeKey];

  if (Glyph) {
    return <Glyph className={className} size='1em' />;
  }

  return (
    <FontAwesomeIcon
      className={className}
      icon={BLEND_ATTRIBUTE_ICONS[attributeKey] || faCircleInfo}
    />
  );
};

BlendAttributeIcon.propTypes = {
  attributeKey: PropTypes.string.isRequired,
  className: PropTypes.string,
};

BlendAttributeIcon.defaultProps = { className: '' };

export default BlendAttributeIcon;
